export enum GasUnit {
    'ppb' = 0,
    'ppm' = 1
}

export enum WindspeedUnit {
    'm/sec' = 0,
    'mph' = 1,
    'ft/sec' = 2,
    'km/hr' = 3,
    'knot' = 4
}

export enum RainfallUnit {
    'mm/hr' = 0,
    'in/hr' = 1
}

export enum FlowrateUnit {
    'mL/min' = 0,
    'L/min' = 1
}

export enum PmUnit {
    'µg/m³' = 0,
    'mg/m³' = 1
}

export enum TemperatureUnit {
    '°C' = 0,
    '°F' = 1
}

export enum MassUnit {
    'µg' = 0,
    'mg' = 1
}

export enum LengthUnit {
    'cm' = 0,
    'ft' = 1,
}

export enum AreaUnit {
    'cm²' = 0,
    'ft²' = 1
}